/**************************************************
 * Nombre:       Tarjeta_Curso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import tempo from '../../Recursos/foto_profundizacion.png'
import iso from "../../Recursos/iso.svg";
import {useNavigate} from "react-router-dom";


const Tarjeta_Curso = ({item}) => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                boxShadow: 2
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={tempo} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#fff',
                    p: 3,
                    color: theme.palette.primary.main,
                    mt: -10,
                    borderColor: theme.palette.primary.main,
                    borderBottom: 1,
                    borderLeft: 1,
                    borderRight: 1,
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontFamily: NEGRITA, fontSize: 28, fontWeight: 800, lineHeight: 1.1}}>
                        Tecnico uno
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.2}}>
                        Programas prácticos diseñados para una empleabilidad rápida en sectores clave como tecnología,
                        administración, salud e industria
                        Programas prácticos diseñados para
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Button
                        onClick={() => navigate('/Formacion/'+123)}
                        sx={{fontSize: 14, color: 'white'}}
                            startIcon={<img src={iso} style={{width: 20, height: 20, marginRight: 10}}/>}>
                        Ver Detalles
                    </Button>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Tarjeta_Curso